import gql from "graphql-tag";
import {
  currentPrintPdfSettings,
  currentPrintPdfSettings_currentPrintPdfSettings,
} from "@/models/queries/types/currentPrintPdfSettings";

export const PRINT_PDF_SETTINGS_QUERY = gql`
  query currentPrintPdfSettings {
    currentPrintPdfSettings {
      pdfAttachments
      materialCertificate
      technicalDrawing
      characteristicAttachments
      imageAttachments
      defaultLayout
    }
  }
`;
export type PrintPdfSettingsResult = currentPrintPdfSettings;
export type PrintPdfSettings = currentPrintPdfSettings_currentPrintPdfSettings;
